import React from 'react'

import TeamChatUsersButton from './button'
import ManageTeamChatUserModal from './modal'
import { useDisclosure } from '@chakra-ui/react'

export default function TeamChatUsers() {
    const { isOpen, onClose, onOpen } = useDisclosure()

    return (
        <>
            <TeamChatUsersButton onOpen={onOpen} />
            <ManageTeamChatUserModal isOpen={isOpen} onClose={onClose} />
        </>
    )
}
